import React, { useState } from "react";
import { toast } from "sonner";
import { Pin, Tv, EyeOff } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

export function TopStoryButton({ it, pinned, onDone }) {
  const [busy, setBusy] = useState(false);
  async function pin() {
    if (pinned) {
      try { await api.delete("/weddings/mine/top-story"); toast.success("Top story removed"); onDone(); } catch (e) { toast.error(formatApiError(e)); }
      return;
    }
    const headline = window.prompt("Headline for your Top Story", it.news_headline || it.caption || "");
    if (headline === null) return;
    setBusy(true);
    try { await api.put("/weddings/mine/top-story", { item_id: it.item_id, headline }); toast.success("Pinned to the top of your site"); onDone(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  return (
    <button onClick={pin} disabled={busy} title={pinned ? "Unpin Top Story" : "Pin as Top Story"} className={`p-1 rounded-full ${pinned ? "bg-[#d41a24] text-white" : "bg-[var(--bg-warm)] text-[var(--muted)] hover:text-[var(--ink)]"}`} data-testid={`pin-top-story-${it.item_id}`}>
      <Pin className="w-3 h-3" />
    </button>
  );
}

export function WallToggle({ it, onDone }) {
  if (!it.shared_at) return null;
  async function flip() {
    await api.post(`/memories/${it.item_id}/wall?hidden=${!it.wall_hidden}`);
    toast.success(it.wall_hidden ? "Back on the TV news wall" : "Hidden from the TV news wall");
    onDone();
  }
  const I = it.wall_hidden ? EyeOff : Tv;
  return (
    <button onClick={flip} title={it.wall_hidden ? "Hidden from TV wall" : "Showing on TV wall"} className={`p-1 rounded-full ${it.wall_hidden ? "bg-[var(--bg-warm)] text-[var(--muted)]" : "bg-[var(--ink)] text-white"}`} data-testid={`wall-toggle-${it.item_id}`}>
      <I className="w-3 h-3" />
    </button>
  );
}
